module.exports = __webpack_public_path__ + "img/pattern2.c290b11.svg";